import React from 'react';
import {styled} from '@mui/material/styles';
import {CircularProgress} from "@mui/material";
import PlaceholderImage from "../PlaceholderImage";
import Paper from "@mui/material/Paper";
import {useSelector} from "react-redux";
import grey from "@mui/material/colors/grey";
import SaveButton from "./SaveButton";


const StyledPaper = styled(Paper)(({theme, loaded}) => ({
    position: 'relative',
    backgroundColor: grey[900],
    height: '97%',
    maxWidth: loaded ? '97%' : 600,
    maxHeight: loaded ? '97%' : '95%',
    boxShadow: '0 0 20px rgba(255,255,255,0.15)',
    border: `1px solid ${grey[900]}`,
    [theme.breakpoints.up('lg')]: {
        minWidth: loaded ? 0 : theme.breakpoints.values.sm,
    },
}));

const StyledProgress = styled(CircularProgress)(({theme}) => ({
    color: grey[800],
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginTop: -progressSize/2,
    marginLeft: -progressSize/2,
}));

const progressSize = 100;


export default function DesktopImagePreview() {

    const manipulating = useSelector(state => state.image.manipulating);
    const currentURL = useSelector(state => state.image.currentURL);
    const width = useSelector(state => state.image.width);

    return (
        <StyledPaper elevation={3} loaded={width > 0 ? 1 : 0}>
            {manipulating && <StyledProgress size={progressSize} />}
            <PlaceholderImage src={currentURL} alt="preview upload" />
            <SaveButton/>
        </StyledPaper>
    );
}

